import axios from "axios";
import { API_URL } from "../../const";
//***********RPC NON REPORT DETAILS START**************************/
export const fetchRpcNonReport = (fetchData: JSON) => {
  const data = {
    RPCReportToken: fetchData,
  };

  const url = `${API_URL}GetRPCReport`;
  // ISSUE-007: this report currently runs 20-30s server-side (N+1 aggregation
  // over a large call table). Give it a generous client timeout so a slow but
  // valid response is NOT dropped and mis-read as "no data". The real fix is a
  // backend query rewrite; this keeps the result from being lost meanwhile.
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
    timeout: 120000,
  });
};
//***********RPC NON REPORT DETAILS END**************************/

//**************RPC NON REPORT CAMPAIGN DETAILS START************/
export const fetchRpcNonReportCampaign = (fetchData: JSON) => {
  const data = {
    FetchRPCReportCampaignToken: fetchData,
  };

  const url = `${API_URL}FetchCampaignDetails`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
//**************RPC NON REPORT CAMPAIGN DETAILS END************/
//**************COMMON EXPORT PAGE DETAILS START***************/
export const ComonExportPage = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
//**************COMMON EXPORT PAGE DETAILS END***************/
